import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface DeleteConfirmationProps {
    onConfirm: () => void;
    onCancel: () => void;
    message: string;
}

const DeleteConfirmation: FC<DeleteConfirmationProps> = ({ onConfirm, onCancel, message }) => {
    const { t } = useTranslation();
    const handleCancel = (e?: MouseEvent<HTMLButtonElement>) => {
        if (e) e.preventDefault();
        onCancel();
    };

    return (
        <Modal
            isOpen={true}
            onClose={onCancel}
            size="sm"
            hideHeader={true}
        >
            <div className="p-2 sm:p-4 text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-red-50 text-red-500 mx-auto mb-4 flex items-center justify-center">
                    <svg
                        className="w-8 h-8"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        ></path>
                    </svg>
                </div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">
                    {t("dashboard.deletePrompt", { name: message })}
                </h3>
                <p className="text-xs text-gray-500 mb-6">
                    {t("common.cannotUndo", "This action cannot be undone. Are you sure you want to proceed?")}
                </p>
                <div className="flex flex-col-reverse sm:flex-row justify-center gap-2 sm:gap-3">
                    <button
                        type="button"
                        className="w-full sm:w-auto text-gray-700 bg-white hover:bg-gray-100 border border-gray-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center cursor-pointer transition-colors"
                        onClick={handleCancel}
                    >
                        {t("dashboard.noCancel", "No, Cancel")}
                    </button>
                    <button
                        type="button"
                        className="w-full sm:w-auto text-white bg-red-600 hover:bg-red-700 font-medium rounded-lg text-sm px-4 py-2.5 text-center cursor-pointer transition-colors"
                        onClick={onConfirm}
                    >
                        {t("dashboard.yesImSure", "Yes, Confirm")}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmation;
